import React from "react";

import Table from "components/Table";
import { invoiceLinesColumns } from "./columns";

interface IProps {
  isLoading: boolean;
  loadData: () => void;
  data: any[];
}

class InvoiceLines extends React.PureComponent<IProps> {
  public componentDidMount() {
    this.props.loadData();
  }

  public render() {
    const { data, isLoading } = this.props;

    return (
      <Table
        columns={invoiceLinesColumns}
        dataSource={data}
        isLoading={isLoading}
      />
    );
  }
}

export default InvoiceLines;
